import { IMatch } from '../pages/tourDetails/TournamentPlay/components/PlayTag/PlayTag';

export type BracketCellGroup = {
  cellId: string;
  matches: IMatch[];
  isLegacySingle: boolean;
};

export function groupMatchesByBracketCell(matches: IMatch[]): BracketCellGroup[] {
  const byCell = new Map<string, IMatch[]>();
  const legacy: IMatch[] = [];

  for (const m of matches) {
    const cid = m.bracketCellId;
    if (typeof cid === 'string' && cid.length > 0) {
      if (!byCell.has(cid)) {
        byCell.set(cid, []);
      }
      byCell.get(cid)!.push(m);
    } else {
      legacy.push(m);
    }
  }

  const groups: BracketCellGroup[] = [];

  for (const [cellId, cellMatches] of byCell) {
    cellMatches.sort(
      (a, b) => (a.bracketCellMatchIndex ?? 0) - (b.bracketCellMatchIndex ?? 0),
    );
    groups.push({ cellId, matches: cellMatches, isLegacySingle: false });
  }

  for (const m of legacy) {
    groups.push({
      cellId: `legacy-${m.id}`,
      matches: [m],
      isLegacySingle: true,
    });
  }

  return groups.sort((a, b) => {
    const sa = a.matches[0]?.sortKey ?? 0;
    const sb = b.matches[0]?.sortKey ?? 0;
    return Number(sa) - Number(sb);
  });
}
